<template>
  <footer class="main-footer sticky footer-type-1">
    <div class="footer-inner">
      <!-- 版权信息 -->
      <div class="footer-text">
        <a href="#"><strong>安徽合大数据服务有限公司</strong></a>
<!--        域名备案号： <a href="http://viggoz.com" target="_blank"><strong>皖ICP备2023028790号</strong></a>-->
      </div>
      
<!--      <div class="go-up">-->
<!--        <a href="#" rel="go-top"><i class="fa-angle-up"></i></a>-->
<!--      </div>-->
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer'
}
</script>

<style>

</style>
